var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"cdd98cd60d5921dbcacb438b91213fa1231eef85"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["platform-ui@compono"]={id:"cdd98cd60d5921dbcacb438b91213fa1231eef85"};
      